import CloseIcon from "@mui/icons-material/Close";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import {
  Box,
  IconButton,
  Modal,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import { gray } from "../../../../theme/themePrimitives";

interface Recipient {
  name: string;
  email: string;
}

interface RecipientsPreviewModalProps {
  open: boolean;
  onClose: () => void;
  recipients: Recipient[];
}

export const RecipientsPreviewModal: React.FC<RecipientsPreviewModalProps> = ({
  open,
  onClose,
  recipients,
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          maxHeight: "90vh",
          overflowY: "auto",
          backgroundColor: "white",
          borderRadius: "8px",
          boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.24)",
          padding: "24px",
          width: "500px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 3,
          }}
        >
          <Typography variant="h6" fontWeight={600}>
            Recepients preview
          </Typography>
          <IconButton
            onClick={onClose}
            sx={{ padding: 0 }}
          >
            <CloseIcon sx={{ color: "#98A2B3" }} />
          </IconButton>
        </Box>

        <Stack spacing={2}>
          {recipients.map((recipient, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
              }}
            >
              <Box
                sx={{
                  width: 40,
                  height: 40,
                  borderRadius: "50%",
                  backgroundColor: gray[100],
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <PersonOutlineIcon sx={{ color: "#6B7280" }} />
              </Box>
              <Box>
                <Typography variant="body1" fontWeight={500}>
                  {recipient.name}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {recipient.email}
                </Typography>
              </Box>
            </Box>
          ))}
        </Stack>
      </Box>
    </Modal>
  );
};
